__turbopack_context__.v({
  "capsule": "feature-bloc-module__vQMBBa__capsule",
  "featureBloc": "feature-bloc-module__vQMBBa__featureBloc",
  "title": "feature-bloc-module__vQMBBa__title",
});
